import _ from "lodash";

export const prepareTextListForSearch = (text: string) => {
    let textList: any[] = [];
    const characters = [' ', '.', ',', '-'];

    textList = splitTextWithAllCharacters(text, characters);
    textList = textList.concat(splitTextWithAllWords(text));
    textList = textList.concat(splitTextWithPipe(text));

    return _.uniq(textList);
}

export const splitTextWithPipe = (text: string) => {
    const textList: any[] = [];
    const words = _.split(text, "|");
    let singleLine;

    _.forEach(words, (word) => {
        singleLine = _.toLower(_.trim(word));
        textList.push(singleLine);

        if (singleLine.indexOf(' - ') !== -1) {
            textList.push((_.split(singleLine, ' - '))[0]);
        }
    });

    // console.log('1 ---> textList: ', textList);
    return textList;
};

export const splitTextWithAllWords = (text: string) => {
    let textList: any[] = [];
    let words = '';

    _.forEach(_.words(_.toLower(text)), word => {
        words += ' ' + word;
        textList.push(_.trim(words));
    });

    // console.log('1 ---> textList: ', textList);
    return textList;
}

export const splitTextWithAllCharacters = (text: string, characters: any[]) => {
    let textList: any[] = [];
    textList.push(_.toLower(text));

    _.forEach(characters, character => {
        textList = splitWithCharacter(textList, character);
    });

    // console.log('1 ---> textList: ', textList);
    return textList;
}

export const splitWithCharacter = (inputTextList: any[], character: any) => {
    let textList: any[] = [];

    _.forEach(inputTextList, tempInputText => {
        let tempTextList = _.split(tempInputText, character);
        tempTextList = splitWithEachLetter(tempTextList);
        textList = textList.concat(_.compact(tempTextList));
    });

    return _.uniq(textList);
}

export const splitWithEachLetter = (inputTextList: string[]) => {
    let textList: any[] = [];

    _.forEach(inputTextList, tempInputText => {
        const letterList = _.split(tempInputText, '');
        let letterText = '';

        const tempTextList: any[] = [];
        _.forEach(letterList, letter => {
            letterText += letter;
            tempTextList.push(letterText);
        });

        textList = textList.concat(_.compact(tempTextList));
    });

    return _.uniq(textList);
}
